const DEFAULT_PRODUCTION_API_BASE_URL =
  typeof window !== 'undefined' ? window.location.origin : 'https://start-us.com';

const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '');

export const API_BASE_URL = trimTrailingSlash(
  import.meta.env.VITE_API_BASE_URL ||
    (import.meta.env.PROD ? DEFAULT_PRODUCTION_API_BASE_URL : '')
);

export function buildApiUrl(path = '') {
  if (!path) {
    return API_BASE_URL;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

export function getOauthLoginUrl(provider) {
  return buildApiUrl(`/auth/${provider}/login`);
}

export function getOauthLoginUrlWithReturn(provider, returnUrl, stateNonce = '') {
  const loginUrl = new URL(
    buildApiUrl(`/auth/${provider}/login`),
    typeof window !== 'undefined' ? window.location.origin : 'https://start-us.com'
  );
  if (returnUrl) {
    loginUrl.searchParams.set('return_url', returnUrl);
  }
  if (stateNonce) {
    loginUrl.searchParams.set('state_nonce', stateNonce);
  }

  return loginUrl.toString();
}
